import { Perfil } from "@/contexts/autorizacao/perfil/model/Perfil";
import { Permissao } from "@/contexts/autorizacao/permissao";
import { api } from "@/shared/api/api";

export const createPerfilApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<Perfil[]>(`/perfis/todos`, { headers });
    return data;
  };

  const getPermissoes = async (perfilId: number) => {
    const { data } = await api.get<Permissao[]>(
      `/perfis/${perfilId}/permissoes`,
      { headers }
    );
    return data;
  };

  const updatePermissoes = async (
    id: number,
    content: { permissoes: Permissao[] }
  ) => {
    await api.put(`/perfis/${id}/permissoes`, content, { headers });
  };

  return { listAll, getPermissoes, updatePermissoes };
};
